import { ref, reactive, watchEffect, watch, nextTick } from 'vue'
import type { Umsokn } from '@/types/Umsokn'
import useGatewayApi from '@/composables/useGatewayApi'

const api = useGatewayApi()

const umsokn = ref<any>(null)
const umsoknir = ref(null)
const files = ref(null)
const loading = ref(false)
const medlimur = ref(true)

export function useUmsokn() {

  async function createUmsokn(type: number, submit = false) {
    loading.value = true
    umsokn.value = null
    try {
      const res = await api.get(`api/v1/core/coredata/create/umsokn?type=${type}${submit ? '&submit=true' : ''}`)
      umsokn.value = { ...res } 
    } catch (e: any) {
      if (e?.response?.status === 401) medlimur.value = false
      console.error('❌ Umsókn was not created:', e)
    } finally {
      loading.value = false
    }
    return umsokn.value
  }

  async function updateUmsokn(type: string) {
    // type can be:
    // 'lifeyrisumsokn', 'lanaumsokn', 'lan-nafnabreyting', 'lan-vedflutning',
    // 'langreidslufrest', 'sereignumsokn', 'utgreidslusereignumsokn', 'sereignbreyting',
    // 'afsal-sereign', 'uppsogn-samning-sereign', 'radstofun-idjgalds',
    // 'nyr-launagreidandi', 'tilgreind-sereign', 'barnalifeyrir',
    // 'makalifeyrir', 'gogntiltr', ororkuumsokn
    return api.put(`api/v1/core/coredata/update/${type}`, umsokn.value)
  }

  async function sendLifeyrisUmsokn() {
    return api.post('api/v1/core/coredata/send/lifeyrisumsokn', umsokn.value)
  }

  async function setCoreDataUmsoknir() {
    const res = await api.get('api/v1/core/coredata/projects')
    umsoknir.value = res.data
  }

  async function createLanaUmsokn() {
    const res = await api.get('api/v1/core/coredata/create/lanaumsokn')
    umsokn.value = res.data
  }

  async function uploadFile(file: File, umsoknItem: { id: string | number; type: number; fileSpace: number }) {
    const formData = new FormData()
    formData.append('file', file)
    //formData.append('projectId', umsoknItem.id.toString())
    formData.append('type', umsoknItem.type.toString())
    formData.append('filespace', umsoknItem.fileSpace.toString())

    return api.postFile('api/v1/core/coredata/update/file', formData)

  }

  async function setFiles(umsoknItem: { id: string | number; type: number; fileSpace: number }) {
    return api.get(
      `api/v1/core/coredata/umsokn/files?projectId=${umsoknItem.id}&type=${umsoknItem.type}&filespace=${umsoknItem.fileSpace}`
    )
  }

  async function deleteFile(fileId: number) {
    return api.del(`api/v1/core/coredata/delete/file?fileid=${fileId}`, null)
  }

  async function cancelContract(payload: any) {
    return api.post(`api/v1/core/coredata/delete/contract`, payload)
  }


const onLoadedCallbacks: (() => void)[] = []

function onLoaded(cb: () => void) {
  if (umsokn.value?.id) {
    // Delay ensures it runs after the current navigation + reactive flush
    setTimeout(cb, 0)
  } else {
    onLoadedCallbacks.push(cb)
  }
}

  // fire all callbacks once umsokn has data
watch(
  () => umsokn.value,
  (u) => {
    if (u?.id && onLoadedCallbacks.length) {
      // wait one tick so nested properties settle
      nextTick(() => {
        onLoadedCallbacks.forEach(cb => cb())
        onLoadedCallbacks.length = 0
      })
    }
  },
  { deep: false }
)

  return {
    umsokn,
    umsoknir,
    files,
    loading,
    medlimur,

    createUmsokn,
    updateUmsokn,
    sendLifeyrisUmsokn,
    setCoreDataUmsoknir,
    createLanaUmsokn,
    uploadFile,
    setFiles,
    deleteFile,
    cancelContract,
    onLoaded
  }
}
